import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {
    Depot,
    InspectionBatch, ListDepotsGQL, ListDepotsQueryVariables,
    ListInspectionBatchesGQL,
    ListInspectionBatchesQueryVariables
} from '../../../services/graphql-service/generated/graphql.service';
import {map, take} from 'rxjs/operators';
import {NavigationExtras, Router} from '@angular/router';
import {Auth} from 'aws-amplify';
import {AuthService} from '../../../services/auth-service/auth.service';
import {ConfigService} from '../../../services/config-service/config.service';

@Component({
    selector: 'app-select-view-content',
    templateUrl: './select-content.component.html',
    styleUrls: ['./select-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectContentComponent implements OnInit {
    inspectionBatchesSource: BehaviorSubject<InspectionBatch[]>;
    inspectionBatches$: Observable<InspectionBatch[]>;

    depotsSource: BehaviorSubject<Depot[]>;
    depots$: Observable<Depot[]>;

    selectedContent = null;

    buttonText = 'View';

    contentTypes = [];

    selectedContentType = null;

    constructor(private router: Router,
                public config: ConfigService,
                public listInspectionBatches: ListInspectionBatchesGQL,
                public listDepots: ListDepotsGQL,
                public authService: AuthService) {

        this.inspectionBatchesSource = new BehaviorSubject<InspectionBatch[]>(null);
        this.inspectionBatches$ = this.inspectionBatchesSource.asObservable();

        this.depotsSource = new BehaviorSubject<Depot[]>(null);
        this.depots$ = this.depotsSource.asObservable();

        this.contentTypes = [
            {
                name: 'Inspection Batch',
                id: 'CONTENT_INSPECTION_BATCH'
            },
            {
                name: this.config.getDepotLabel(),
                id: 'CONTENT_DEPOT'
            },
            // // {
            // //     name: 'Feeder',
            // //     id: 'CONTENT_FEEDER'
            // // },
            // {
            //     name: 'Pole Name',
            //     id: 'CONTENT_POLE_NAME'
            // },
            // {
            //     name: 'Pole ID',
            //     id: 'CONTENT_POLE_ID'
            // },
            // // {
            // //     name: 'Image',
            // //     id: 'CONTENT_IMAGE'
            // // },
        ];

    }

    get inspectionBatches(): InspectionBatch[] {
        return this.inspectionBatchesSource.getValue();
    }

    set inspectionBatches(value: InspectionBatch[]) {
        this.inspectionBatchesSource.next(value);
    }

    get depots(): Depot[] {
        return this.depotsSource.getValue();
    }

    set depots(value: Depot[]) {
        this.depotsSource.next(value);
    }

    ngOnInit() {
    }

    inspectClicked() {
        if (this.selectedContent !== null) {

            const navigationExtras: NavigationExtras = {
                queryParams: {}
            };

            switch (this.selectedContentType) {
                case 'CONTENT_INSPECTION_BATCH':
                    navigationExtras.queryParams = {inspection_batch_id: this.selectedContent};
                    break;
                case 'CONTENT_DEPOT':
                    navigationExtras.queryParams = {depot_id: this.selectedContent};
                    break;
                case 'CONTENT_POLE_NAME':
                    navigationExtras.queryParams = {pole_name: this.selectedContent};
                    break;
                case 'CONTENT_POLE_ID':
                    navigationExtras.queryParams = {pole_id: this.selectedContent};
                    break;
            }

            this.router.navigate(['/cropping'], navigationExtras);
        }
    }

    onContentTypeChange(contentType) {
        console.log('onContentTypeChange: ', contentType);

        switch (contentType.id) {
            case 'CONTENT_INSPECTION_BATCH':
                this.loadInspectionBatches();
                break;
            case 'CONTENT_DEPOT':
                this.loadDepots();
                break;
            case 'CONTENT_POLE_NAME':
            case 'CONTENT_POLE_ID':
                this.selectedContent = '';
                break;
        }
    }

    loadInspectionBatches() {
        const variables: ListInspectionBatchesQueryVariables = {
            limit: 1000
        };

        const userId = this.authService.userId;

        // If we are inspecting, only list batches assigned to the user
        if (this.router.url.indexOf('inspect') !== -1) {
            variables.filter = {userID: {eq: userId}};
            this.buttonText = 'Inspect';
        }

        // If the user is in the 'client' group, filter to only include batches shared with them
        // if (this.authService.isClient ) {
        //     variables.filter = { sharedWithClient: { eq: true}};
        // }

        if (userId) {
            this.listInspectionBatches.fetch(
                variables
            ).pipe(map(result => result.data.listInspectionBatches.items))
                .subscribe((batches) => {
                        this.inspectionBatches = [...batches].sort((a, b) => {
                            const x = a.inspectionBatchName.toLowerCase();
                            const y = b.inspectionBatchName.toLowerCase();
                            if (x < y) {
                                return -1;
                            }
                            if (x > y) {
                                return 1;
                            }
                            return 0;
                        });
                    }
                );
        }
    }

    loadDepots() {
        const variables: ListDepotsQueryVariables = {
            limit: 1000
        };

        const userId = this.authService.userId;

        // If the user is in the 'client' group, filter to only include batches shared with them
        // if (this.authService.isClient ) {
        //     variables.filter = { sharedWithClient: { eq: true}};
        // }

        if (userId) {
            this.listDepots.fetch(
                variables
            ).pipe(map(result => result.data.listDepots.items))
                .subscribe((depots) => {
                        console.log('Depots: ', depots);


                        this.depots = [...depots].sort((a, b) => {
                            const x = a.name.toLowerCase();
                            const y = b.name.toLowerCase();
                            if (x < y) {
                                return -1;
                            }
                            if (x > y) {
                                return 1;
                            }
                            return 0;
                        });
                    }
                );
        }
    }
}
